const productAll = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/products`);
    const data = await response.json();

    if (!data || !Array.isArray(data)) {
      console.error("Invalid data format received:", data);
      return [];
    }

    return data.map((product) => ({
      id: product.id,
      name: product.name,
      metadesc: product.metadesc,
      metakey: product.metakey,
      price: product.price,
      description: product.description,
      stock_code: product.stock_code,
      category: Array.isArray(product.category) ? product.category : [],
      tags: Array.isArray(product.tags) ? product.tags : [],
      color: product.color,
      default_images: Array.isArray(product.default_images)
        ? product.default_images
        : [],
      color_images: Array.isArray(product.color_images)
        ? product.color_images
        : [],
      stock_quantity: product.stock_quantity,
      availability: product.availability,
      rating: product.rating,
      attributes: product.attributes,
      created_at: product.created_at,
      updated_at: product.updated_at,
    }));
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

export default productAll;
